var map = {
	"./de.json": 1491,
	"./es.json": 1492,
	"./fr.json": 1493,
	"./id.json": 1494,
	"./it.json": 1495,
	"./nl_NL.json": 1496,
	"./pt.json": 1497
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 705;


//////////////////
// WEBPACK FOOTER
// ./app/i18n/locales ^\.\/.*\.json$
// module id = 705
// module chunks = 1